import React, {PropTypes} from 'react';
import '../../styles/messagePane.scss';
import Textarea from 'react-textarea-autosize';
import {TYPE_YOUR_MESSAGE} from '../../constants/messages';

const MessagePane = ({handleChange, handleSend, message}) => {

  const onKeyDown = e => {
    if (e.which === 13 && !(e.shiftKey || e.ctrlKey)) {
      if (message.trim()) {
        handleSend();
      }
      e.preventDefault();
    }
  };

  const onChange = e => handleChange(e.target.value);

  return (
    <div className="message-pane-wrapper">
      <Textarea
        maxRows={5}
        className="message-pane-input"
        value={message}
        onKeyDown={onKeyDown}
        onChange={onChange}
        placeholder={TYPE_YOUR_MESSAGE}
        />
      {message.trim() ? <button className="send-button" onClick={handleSend}/> : null}
    </div>
  );
};

MessagePane.propTypes = {
  handleChange: PropTypes.func,
  handleSend: PropTypes.func,
  message: PropTypes.string
};

export default MessagePane;



// WEBPACK FOOTER //
// ./chat-app/components/MessagePane/MessagePane.js